import * as React from "react";
import {useColorScheme} from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Select, {SelectProps} from "@mui/material/Select";

export default function ColorModeSelect(props: SelectProps) {
    const {mode, setMode} = useColorScheme();
    if (!mode) {
        return null;
    }
    return (
        <Select
            value={mode}
            size={"small"}
            onChange={(event) =>
                setMode(event.target.value as "system" | "light" | "dark")
            }
            SelectDisplayProps={{
                // @ts-ignore
                "data-screenshot": "toggle-mode",
            }}
            {...props}
        >
            <MenuItem value="system">默认</MenuItem>
            <MenuItem value="light">浅色</MenuItem>
            <MenuItem value="dark">深色</MenuItem>
        </Select>
    );
}
